// extracted by mini-css-extract-plugin
export var card = "Z_dc";
export var textContainer = "Z_dd";